require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./thankful-for-the-holiday-break.json") })
        }
      }, "path---thankful-for-the-holiday-break");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---thankful-for-the-holiday-break!./.cache/json/thankful-for-the-holiday-break.json
// module id = 571
// module chunks = 231608221292675